import React from "react";
import Help from "./Help";

function Home() {

        return (<Help />);
        
};

export default Home;